<script setup>
import { useTheme } from "vuetify";
const theme = useTheme();
const props = defineProps({
    height: {
        type: String,
        default: '56',
    },

    darkLogo: {
        type: Boolean,
        default: false,
    },
    width: {
        type: String,
        default: 'auto',
    },
    mdWidth: {
        type: String,
        default: 'auto',
    },
    maxWidth: {
        type: String,
        default: '180px',
    },
    lightLogo: {
        type: Boolean,
        default: false,
    },
});

</script>
<template>
    <Link href="/" class="flex items-center">
    <v-img v-if="theme.global.current.value.dark && !lightLogo || darkLogo" alt="logo"
        :src="$page.props.setting.home_logo" :lazy-src="$page.props.setting.home_logo" :height="height" :width="width"
        :max-width="maxWidth"
        class="object-contain" />
    <v-img v-else alt="logo" :src="$page.props.setting.home_logolight" :lazy-src="$page.props.setting.home_logolight"
        :height="height" :width="width"
        :max-width="maxWidth"
        class="object-contain" />
    </Link>
</template>
